// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import PageView from 'syft-acp-core/components/PageView'
import WorkerPointTransactionsListWrapper from 'syft-acp-core/entities/WorkerPointTransactions/WorkerPointTransactionsListWrapper'
import { WorkerSubNavigation } from './SubNavigation'

type Props = RouteComponentProps<{
  id: string
}>

export const EntityWorkersPointTransactionsList = ({ match: { params } }: Props) => {
  return (
    <>
      <WorkerSubNavigation workerID={params.id} />
      <PageView title={[`Levels Transactions for worker ${params.id}`]}>
        <WorkerPointTransactionsListWrapper workerID={params.id} />
      </PageView>
    </>
  )
}
